import { defineComponent } from "vue";
import InputWrapper from "./component-library16.mjs";
import { useLabeledInput } from "./component-library243.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "checkbox-input",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean },
    large: { type: Boolean },
    hideAsterisk: { type: Boolean },
    idPrefix: { default: void 0 },
    placeholder: { default: void 0 },
    inputClass: { default: void 0 },
    maxlength: { default: void 0 },
    inputProps: { default: void 0 },
    value: { type: [Boolean, null], default: void 0 }
  },
  emits: ["input", "focus"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const { inputWrapperProps, inputFieldProps, focus, onInput } = useLabeledInput(props, emits);
    const onChange = (event) => {
      var _a;
      if (props.readonly)
        return;
      emits("input", (_a = event.target) == null ? void 0 : _a.checked);
    };
    expose({ focus, onChange, onInput });
    return { __sfc: true, props, emits, inputWrapperProps, inputFieldProps, focus, onInput, onChange, InputWrapper };
  }
});
export {
  _sfc_main as default
};
